import { type FC } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { useIntl } from 'react-intl'

import { AfterSalesImageControl } from '../../../after-sales'
import { type ContactFormValues } from '../../model/ContactFormValues'

const MAX_FILE_SIZE = 15_728_640
const MAX_IMAGES = 5

export const DirectContactFormImageUploadField: FC<{
  isMandatory: boolean
}> = ({ isMandatory }) => {
  const intl = useIntl()
  const { control, trigger } = useFormContext<ContactFormValues>()

  return (
    <Controller
      control={control}
      name="images"
      render={({ field, fieldState }) => (
        <AfterSalesImageControl
          errorImageUpload={fieldState.error?.message}
          isMandatory={isMandatory}
          maxImages={MAX_IMAGES}
          onChangeImageUpload={(files) => {
            field.onChange(files)
            void trigger('images')
          }}
          showMaxImagesNotification
        />
      )}
      rules={{
        validate: (files) => {
          if (files.some((file) => file.size > MAX_FILE_SIZE)) {
            return intl.formatMessage({
              id: 'damagedProducts.validation.fileTooLargeError',
            })
          }

          if (isMandatory && files.length === 0) {
            return intl.formatMessage({
              id: 'damagedProducts.validation.pleaseAddAnImage',
            })
          }

          return true
        },
      }}
      shouldUnregister
    />
  )
}
